module.exports = __webpack_public_path__ + "img/lpfv-pc-3000.66f9dbdf.png";